// ============================================
// INFRASTRUCTURE - Dashboard Repository
// ============================================

import { axiosClient } from './axios-client';
import type { DashboardSummary, DashboardKpis } from '../../domain/entities';
import type { DashboardFiltros } from '../../domain/dtos';

export const dashboardRepository = {
  /**
   * Obtener resumen del dashboard
   */
  async getSummary(filtros?: DashboardFiltros): Promise<DashboardSummary> {
    const { data } = await axiosClient.get<DashboardSummary>('/dashboard/summary', {
      params: filtros,
    });
    return data;
  },

  /**
   * Obtener KPIs del dashboard
   */
  async getKpis(): Promise<DashboardKpis> {
    const { data } = await axiosClient.get<DashboardKpis>('/dashboard/summary');
    return data;
  },

  /**
   * Obtener gráfico de ventas por período
   */
  async getVentasPorPeriodo(params: {
    fechaInicio: string;
    fechaFin: string;
    agrupacion: 'dia' | 'semana' | 'mes';
  }): Promise<Array<{ fecha: string; cantidad: number; total: number }>> {
    const { data } = await axiosClient.get('/dashboard/ventas-periodo', {
      params,
    });
    return data;
  },
};
